/**
 * Palette token constants for the tax-regime-selector feature.
 *
 * Resolves to the global CSS custom properties defined in tokens.css.
 * Same pattern as service-request/tokens.ts — colocate the strings so we
 * don't sprinkle the magic CSS strings across components.
 */

export const PALETTE_FOREST = 'hsl(var(--palette-forest, 176 72% 17%))';
export const PALETTE_AMBER  = 'hsl(var(--palette-amber,   33 100% 50%))';
export const PALETTE_MINT   = 'hsl(var(--palette-mint,   154  38% 94%))';
export const PALETTE_CREAM  = 'hsl(var(--palette-cream,   40 100% 98%))';
export const PALETTE_BUTTER = 'hsl(var(--palette-butter,  44  90% 90%))';
